export enum HotKey {
  'One' = 'Digit1',
  'Two' = 'Digit2',
  'Four' = 'Digit4',
  'Zero' = 'Digit0',
  'Numpad1' = 'Numpad1',
  'Numpad2' = 'Numpad2',
  'Numpad4' = 'Numpad4',
  'B' = 'KeyB',
  'C' = 'KeyC',
  'E' = 'KeyE',
  'L' = 'KeyL',
  'S' = 'KeyS',
  'T' = 'KeyT',
  'V' = 'KeyV',
  'Y' = 'KeyY',
  'Z' = 'KeyZ',
  'ArrowRight' = 'ArrowRight',
  'ArrowLeft' = 'ArrowLeft',
  'BracketRight' = 'BracketRight',
  'BracketLeft' = 'BracketLeft',
  'CtrlLeft' = 'ControlLeft',
  'CtrlRight' = 'ControlRight',
  'Equal' = 'Equal',
  'Escape' = 'Escape',
  'Minus' = 'Minus',
  'Space' = 'Space',
}

/**
 * ***Description of HOT KEYS***
 * One (1) - activate single view mode
 * Two (2) - activate two views mode
 * Four (4) - activate four views mode
 * Zero (0) - show/hide
 * B - activate brush tool
 * C - activate view changes tool
 * E - activate eraser tool
 * L - activate lasso tool
 * S - trigger save mask (NOT IMPLEMENTED)
 * T - trigger reset transparency
 * V - trigger reset views
 * ArrowRight - select next slice
 * ArrowLeft - select previous slice
 * BracketRight (]) - incerease tool size
 * BracketLeft ([) - decrease tool size
 * CtrlLeft - trigger zoom tool for active view
 * Escape - trigger exit interaction or close context menu or reset edit image tool (see priority)
 * Plus (Shift + Equal) - activate lasso default mode
 * Minus - activate lasso subtract mode
 * Space - select next view
 * Ctrl + Z  - trigger undo
 * Ctrl + Y - trigger redo
 * Ctrl + S - trigger save
 */
